import $ from 'jquery'
import { loadMore } from '@/js/pages/user/job/index'

const main = () => {
    if (document.querySelector('#page-user-home') == null) return;

    const scrollIo = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            loadMore('#job-all');
        }
    });
    if(document.querySelector('.c-lists-job__loading')){
        scrollIo.observe(document.querySelector('.c-lists-job__loading'));
    }
}

export default main;
